export interface SearchItem {
  post_id: number;
  post_type: string;
  title: string;
  url: string;
  excerpt?: string;
  feature?: string;
  thumbnail_url?: string;
  badge?: string | null;
  long_excerpt?: string;
}

export type MatchLevel = { label: string; key: 'best' | 'recommend' | 'normal' };

export function getPostTypeLabel(postType: string): string {
  const labels: Record<string, string> = {
    genre: 'ジャンル',
    product: '製品',
    column: 'コラム',
    feature: '特集',
  };
  return labels[postType] ?? postType;
}

export function getCtaLabel(postType: string): string {
  const labels: Record<string, string> = {
    genre: '詳細',
    product: '詳細',
    column: 'コラムを読む',
    feature: '詳細',
  };
  return labels[postType] ?? '詳細';
}

export function getMatchLevel(item: SearchItem): MatchLevel {
  if (item.badge === '最適') return { label: '最適', key: 'best' };
  if (item.badge === 'おすすめ') return { label: 'おすすめ', key: 'recommend' };
  return { label: '通常', key: 'normal' };
}

export function isPointOutsideRect(
  clientX: number,
  clientY: number,
  rect: { left: number; top: number; right: number; bottom: number },
): boolean {
  return (
    clientX < rect.left ||
    clientX > rect.right ||
    clientY < rect.top ||
    clientY > rect.bottom
  );
}

/**
 * 投稿タイプを表示順(order)に基づくランク値へ変換する。
 * order に含まれない型は末尾(order.length)に回す。
 */
export function rankByResultOrder(postType: string, order: string[]): number {
  const index = order.indexOf(postType);
  return index === -1 ? order.length : index;
}

/**
 * カード本文テキストの改行を正規化する。
 * WordPress 本文由来の段落区切り（連続改行）を単一改行に圧縮し、
 * 改行前後の半角空白・タブを除去、前後をトリムする。単一改行は保持する。
 */
export function normalizeExcerpt(text: string): string {
  return text
    .replace(/\r\n?/g, '\n')
    .replace(/[ \t]*\n[ \t]*/g, '\n')
    .replace(/\n{2,}/g, '\n')
    .trim();
}
